import React , {useState}from 'react';
import { FiEdit2, FiTrash2, FiFileText } from "react-icons/fi";
import { toJalaliDate } from '../../utils/dateUtils';


const RequestElement = ({ title, description, created_at, status, onEdit, onView }) => {
  
  const dateStr = toJalaliDate(created_at);
  const timeStr = created_at ? new Date(created_at).toLocaleTimeString('fa-IR', { hour: '2-digit', minute: '2-digit' }) : '';
  const getStatusStyle = (status) => {
    switch (status) {
      case 'تایید شده': return 'bg-emerald-100 text-emerald-700';
      case 'تایید نشده': return 'bg-rose-100 text-rose-700';
      case 'در انتظار': return 'bg-amber-100 text-amber-700';
      case 'ارجاعات': return 'bg-sky-100 text-sky-700';
      default: return 'bg-slate-100 text-slate-700';
    }
  };

  return (
    <tr className="border-b border-slate-100 hover:bg-slate-50/80 transition-all text-center text-sm">
      {/* ساعت */}
 <td className="p-4 font-mono text-slate-600 font-bold">{timeStr || "--:--"}</td>      
      {/* تاریخ */}
  <td className="p-4 text-slate-500">{dateStr || "----/--/--"}</td>
      {/* عنوان */}
  <td className="p-4 font-bold text-slate-800 text-right">{title}</td>
      
      {/* توضیحات */}
  <td className="p-4 text-slate-500 text-right truncate max-w-[200px]">{description}</td>
      {/* وضعیت */}
      <td className="p-4">
        <span className={`px-3 py-1 rounded-full text-[11px] font-bold ${getStatusStyle(status)}`}>
          {status}
        </span>
      </td>

      {/* عملیات */}
      <td className="p-4">
        <div className="flex justify-center items-center gap-2">
          {/* دکمه گزارش */}
          <button 
            onClick={onView} 
            className="p-2 text-slate-400 hover:text-indigo-600 transition-colors"
          >
            <FiFileText size={16} /> 
          </button>
          
          {/* دکمه ویرایش */}
          <button 
            onClick={onEdit} 
            className="p-2 text-slate-400 hover:text-amber-600 transition-colors"
          >
            <FiEdit2 size={16} />
          </button>
          
          {/* دکمه حذف */}
          <button 
            className="p-2 text-slate-400 hover:text-rose-600 transition-colors"
          >
            <FiTrash2 size={16} />
          </button>
        </div>
      </td>
    </tr>
  );
};

export default RequestElement;